var _defs, _rect, _circle, _circle2, _g, _circle3, _circle4, _text, _text2, _text3, _rect2, _circle5, _circle6, _path, _text4, _text5, _rect3, _circle7, _circle8, _circle9, _circle0, _path2, _text6, _text7, _rect4, _circle1, _ellipse, _path3, _text8, _text9, _rect5, _circle10, _path4, _text0, _text1, _rect6, _circle11, _text10, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentHeroOperatingSystemMapDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1040,
    height: 760,
    viewBox: "0 0 1040 760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom development desktop operating system map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "system-card",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07152A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020716"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "system-glow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 14,
    floodColor: "#087CFF",
    floodOpacity: 0.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 30,
    width: 850,
    height: 700,
    rx: 38,
    fill: "url(#system-card)",
    stroke: "#254463",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 336,
    r: 255,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.26
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 336,
    r: 205,
    fill: "none",
    stroke: "#FF2775",
    strokeOpacity: 0.2,
    strokeDasharray: "8 11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5DB3FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeDasharray: "5 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 163L520 336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 163L520 336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 503L520 336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 503L520 336"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 336,
    r: 112,
    fill: "#071D39",
    stroke: "#087CFF",
    strokeWidth: 3,
    filter: "url(#system-glow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 336,
    r: 90,
    fill: "#08152B",
    stroke: "#FF2775",
    strokeOpacity: 0.45
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 322,
    fill: "#78C2FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    textAnchor: "middle",
    fontWeight: 800,
    letterSpacing: 2
  }, "YOUR")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 354,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 29,
    textAnchor: "middle",
    fontWeight: 850
  }, "OPERATION")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 380,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    textAnchor: "middle",
    fontWeight: 650
  }, "ONE CONNECTED SYSTEM")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 115,
    width: 220,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#087CFF",
    strokeOpacity: 0.65
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 163,
    r: 25,
    fill: "#087CFF",
    fillOpacity: 0.11
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 156,
    r: 8,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 177c2-10 7-14 14-14s12 4 14 14",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 158,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "PEOPLE")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 179,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Roles and responsibility")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 115,
    width: 220,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#FF2775",
    strokeOpacity: 0.65
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 163,
    r: 25,
    fill: "#FF2775",
    fillOpacity: 0.11
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 717,
    cy: 163,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 152,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 175,
    r: 5,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M722 163h10l7-8M732 164l7 8",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 767,
    y: 158,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "PROCESS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 767,
    y: 179,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Work and handovers")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 455,
    width: 220,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#30D6A1",
    strokeOpacity: 0.65
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 503,
    r: 25,
    fill: "#30D6A1",
    fillOpacity: 0.11
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 492,
    rx: 15,
    ry: 6,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 492v22c0 3 7 6 15 6s15-3 15-6v-22M155 503c0 3 7 6 15 6s15-3 15-6",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 498,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "DATA")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 519,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Evidence and context")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 455,
    width: 220,
    height: 96,
    rx: 19,
    fill: "#0B2341",
    stroke: "#F5B642",
    strokeOpacity: 0.65
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 503,
    r: 25,
    fill: "#F5B642",
    fillOpacity: 0.11
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M713 513l9-9 8 6 16-20M738 490h8v8",
    fill: "none",
    stroke: "#F5B642",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 767,
    y: 498,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "DECISIONS")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 767,
    y: 519,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 630
  }, "Human-owned action")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 620,
    width: 500,
    height: 70,
    rx: 18,
    fill: "#0B2341",
    stroke: "#2A4B6B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 655,
    r: 6,
    fill: "#30D6A1"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 650,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "MEASURABLE BUSINESS OUTCOME")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 672,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Productivity \xB7 visibility \xB7 accountable decisions")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentHeroOperatingSystemMapDesktop);
export default __webpack_public_path__ + "static/media/custom-development-hero-operating-system-map-desktop.dd389458919ea771f63ac3ff8940f041.svg";
export { ForwardRef as ReactComponent };